// <Icon icon="search" />

import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ icon, ...props }) => {
	const svg = icon ? require(`!raw-loader!../assets/zondicons/${icon}.svg`) : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"></svg>';
	const tag = props.tag ? props.tag : 'span';
	const className = props.iconclass ? 'icon ' + props.iconclass : 'icon';

	return React.createElement(tag, {
		className,
		dangerouslySetInnerHTML: {__html: svg},
		...props
	});
}

Icon.propTypes = {
	icon: PropTypes.string,
	tag: PropTypes.string,
	iconclass: PropTypes.string,
}

export default Icon;
